export let ModalName;

(function (ModalName) {
  ModalName["MAINTENANCE_STAKING"] = "maintenance-staking";
})(ModalName || (ModalName = {}));